import { ReactComponent as ConfegrateActiveIcon } from '../../../assets/icons/sidebar/configeration-active.svg';
import { ReactComponent as ConfegrateIcon } from '../../../assets/icons/sidebar/configeration.svg';
import { ReactComponent as HomeActiveIcon } from '../../../assets/icons/sidebar/sidebar-home-active.svg';
import { ReactComponent as HomeIcon } from '../../../assets/icons/sidebar/sidebar-home.svg';
import { ReactComponent as QRCodeActiveIcon } from '../../../assets/icons/sidebar/sidebar-qrcode-active.svg';
import { ReactComponent as QRCodeIcon } from '../../../assets/icons/sidebar/sidebar-qrcode.svg';
import { ReactComponent as ReportActiveIcon } from '../../../assets/icons/sidebar/sidebar-report-active.svg';
import { ReactComponent as ReportIcon } from '../../../assets/icons/sidebar/sidebar-report.svg';
import { ReactComponent as RevenueActiveIcon } from '../../../assets/icons/sidebar/sidebar-revenue-active.svg';
import { ReactComponent as RevenueIcon } from '../../../assets/icons/sidebar/sidebar-revenue.svg';
import { ReactComponent as StationActiveIcon } from '../../../assets/icons/sidebar/sidebar-station-active.svg';
import { ReactComponent as StationIcon } from '../../../assets/icons/sidebar/sidebar-station.svg';
import { MenuItem } from '../../../interface/menuItem-interfaces';
import { permissionCheck } from '../../../shared-functions/JWTDocodeFunction';

/**
 * Partner Menus List
 */
const PartnerMenu = (): MenuItem[] => [
  {
    id: 'dashboard',
    label: 'dashboard',
    url: '/ev-admin/dashboard',
    svgIcon: <HomeIcon />,
    activeSvgIcon: <HomeActiveIcon />,
    allow: permissionCheck('partnerDashboardView'),
    permissionKey: 'partnerDashboardView',
  },
  {
    id: 'operations',
    label: 'operations',
    svgIcon: <StationIcon />,
    activeSvgIcon: <StationActiveIcon />,
    allow:
      permissionCheck('partnerChargingStationView') ||
      permissionCheck('partnerChargingDevicesView') ||
      permissionCheck('partnerSessionView'),
    children: [
      {
        id: 'facility',
        label: 'Facility',
        url: '/ev-admin/operations/facility-management',
        allow: permissionCheck('charging_station'),
        permissionKey: 'charging_station',
      },
      {
        id: 'chargingStations',
        label: 'chargingStation',
        url: '/ev-admin/operations/charging-station/approved',
        allow: permissionCheck('partnerChargingStationView'),
        permissionKey: 'partnerChargingStationView',
        activeMatch: '/ev-admin/operations/charging-station',
      },

      {
        id: 'chargers',
        label: 'chargers',
        url: '/ev-admin/operations/chargers',
        allow: permissionCheck('partnerChargingDevicesView'),
        permissionKey: 'partnerChargingDevicesView',
      },

      {
        id: 'sessions',
        label: 'sessions',
        url: '/ev-admin/operations/partner-sessions',
        allow: permissionCheck('partnerSessionView'),
        permissionKey: 'partnerSessionView',
      },
    ],
  },

  {
    id: 'revenue',
    label: 'revenue',
    allow: permissionCheck('partnerPayoutView') || permissionCheck('partnerTransactionView'),
    svgIcon: <RevenueIcon />,
    activeSvgIcon: <RevenueActiveIcon />,
    children: [
      {
        id: 'transaction',
        label: 'transactions',
        url: '/ev-admin/revenue/partner-transactions',
        allow: permissionCheck('partnerTransactionView'),
        permissionKey: 'partnerTransactionView',
      },

      {
        id: 'payouts',
        label: 'payouts',
        url: '/ev-admin/revenue/partner-payouts/approved',
        allow: permissionCheck('partnerPayoutView'),
        permissionKey: 'partnerPayoutView',
      },
    ],
  },

  {
    id: 'configuration',
    label: 'configuration',
    allow: permissionCheck('partnerTariffView'),
    svgIcon: <ConfegrateIcon />,
    activeSvgIcon: <ConfegrateActiveIcon />,
    children: [
      {
        id: 'tariffs',
        label: 'Tariffs',
        url: '/ev-admin/tariffs',
        allow: permissionCheck('partnerTariffView'),
        permissionKey: 'partnerTariffView',
      },
    ],
  },

  {
    id: 'reports',
    label: 'reports',
    url: '/ev-admin/reports/energyReport',
    allow: permissionCheck('reporting_tools'),
    svgIcon: <ReportIcon />,
    activeSvgIcon: <ReportActiveIcon />,
    children: [
      {
        id: 'energyReport',
        label: 'energyReport',
        url: '/ev-admin/reports/energyReport',
        allow: permissionCheck('reporting_tools'),
        permissionKey: 'reporting_tools',
      },

      {
        id: 'revenueReport',
        label: 'revenueReport',
        url: '/ev-admin/reports/revenueReport',
        allow: permissionCheck('reporting_tools'),
        permissionKey: 'reporting_tools',
      },

      {
        id: 'bookingsReport',
        label: 'bookingsReport',
        url: '/ev-admin/reports/bookingsReport',
        allow: permissionCheck('reporting_tools'),
        permissionKey: 'reporting_tools',
      },

      {
        id: 'chargerUtilizationReport',
        label: 'chargerUtilizationReport',
        url: '/ev-admin/reports/chargerUtilizationReport',
        allow: permissionCheck('reporting_tools'),
        permissionKey: 'reporting_tools',
      },

      {
        id: 'performanceReport',
        label: 'performanceReport',
        url: '/ev-admin/reports/performanceReport',
        allow: permissionCheck('reporting_tools'),
        permissionKey: 'reporting_tools',
      },

      {
        id: 'maintenanceReport',
        label: 'maintenanceReport',
        url: '/ev-admin/reports/maintenanceReport',
        allow: permissionCheck('reporting_tools'),
        permissionKey: 'reporting_tools',
      },
    ],
  },
  {
    id: 'tools',
    label: 'tools',
    allow: permissionCheck('partnerQrCodeView') || permissionCheck('partnerTariffCalculationView') || permissionCheck('partnerTariffCalculation'),
    svgIcon: <QRCodeIcon />,
    activeSvgIcon: <QRCodeActiveIcon />,
    children: [
      {
        id: 'qrCodeGeneration',
        label: 'qrCodeGeneration',
        url: '/ev-admin/tools/qr-code-generator',
        allow: permissionCheck('partnerQrCodeView'),
        permissionKey: 'partnerQrCodeView',
      },
      {
        id: 'tariffcalculator',
        label: 'tariffcalculator',
        url: '/ev-admin/tools/calculator',
        allow: permissionCheck('partnerTariffCalculationView') || permissionCheck('partnerTariffCalculation'),
        permissionKey: 'partnerTariffCalculationView',
      },
      {
        id: 'vlbc',
        label: 'vlbc',
        url: '/ev-admin/tools/vlbc',
        allow: true,
      },
      {
        id: 'maintenance-scheduling',
        label: 'maintenanceScheduling',
        url: '/ev-admin/tools/maintenance-scheduling',
        allow: true,
      },
    ],
  },
];

export default PartnerMenu;
